import { get } from "lodash";
import Toggle from "PFComponents/toggle/toggle";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PropertyFieldProps } from "../property";
import css from "./properties_fields.module.scss";

export const CheckboxField = ({
  fieldName,
  label,
  required,
  disabled,
  validate,
  onChange
}: PropertyFieldProps) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  const { t } = useTranslation("saasAdmin");

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{
        validate: {
          notBlankIfRequired: (value) => {
            if (required) {
              return value !== undefined || t("filtersConfig.errors.required");
            }
          },
          mutualExclusion: (value) => validate?.(value) || true
        }
      }}
      render={({ field }) => (
        <Toggle
          className={css.checkboxField}
          label={label}
          checked={field.value}
          error={get(errors, field.name)?.message as string}
          onChange={(value) => {
            field.onChange(value);
            onChange?.(fieldName, value);
          }}
          disabled={disabled}
        />
      )}
    />
  );
};
